const normaliseUser = require('./../../../utils/normalise-user')

exports.get = async function (state, userName) {
  const userId = `org.couchdb.user:${userName}`
  const user = await state.dal.user.getOne(state, userId)
  return normaliseUser(user)
}
